import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _cloneDeep from 'lodash/cloneDeep';
import MenuItem from '@mui/material/MenuItem';
import { comparisonParams, filterParams } from '../../../utils/segments';
import { addQueryParams } from '../../../utils/browser';

class Portfolios extends React.Component {
  static defaultProps = {
    searchText: '',
    togglePanel: () => {}
  };

  static propTypes = {
    adPortfolios: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    retailer: PropTypes.object.isRequired,
    mainTimePeriod: PropTypes.object.isRequired,
    searchText: PropTypes.string,
    togglePanel: PropTypes.func
  };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    const { adPortfolios } = this.props;
    this.portfolios = _cloneDeep(adPortfolios);

    this.setState({ portfolios: this.portfolios });
  }

  componentWillReceiveProps(nextProps) {
    const { searchText } = nextProps;

    const filteredPortfolios = this.portfolios.filter(
      (val) => val.displayName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
    );
    this.setState({
      portfolios: filteredPortfolios
    });
  }

  handleTouchTap = (selection) => {
    const { togglePanel, location, retailer, mainTimePeriod } = this.props;
    const entity = {
      id: selection.id,
      type: 'adPortfolio'
    };

    const existingParams = addQueryParams(location, retailer, mainTimePeriod, [...filterParams, ...comparisonParams]);

    togglePanel();
    this.context.router.history.push(`?ctype=${entity.type}&cid=${entity.id}&${existingParams}`);
  };

  showNoPortfolios() {
    const { portfolios } = this.state;

    if (portfolios.length > 0) {
      return null;
    }

    return <div style={{ padding: '10px' }}>No portfolios found.</div>;
  }

  render() {
    const { portfolios } = this.state;
    return (
      <div style={{ padding: '10px' }}>
        {portfolios.map((val) => (
          <MenuItem key={val.categoryId} style={{ fontSize: '14px' }} onClick={() => this.handleTouchTap(val)}>
            {val.displayName}
          </MenuItem>
        ))}
        {this.showNoPortfolios()}
      </div>
    );
  }
}

export default withRouter(connect((state) => state)(Portfolios));
